import type { AtomModel, Font, FormControlSetting, TypeSettings } from '@/app/editor/iframe/atom/Atom.model';
import { getCommonButtonFormControlSettings } from '@/app/utils/commonBtnSettings';
import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';
import throttle from '@/app/utils/throttle';
import STORE from '@/app/store/store';

const formControlSettings: FormControlSetting[] = getCommonButtonFormControlSettings('.gf_add-to-cart', {
  isDynamicModule: true,
}).concat([
  {
    type: 'html:attr',
    name: 'btnId',
    targetSelector: '.gf_add-to-cart',
    property: 'id',
  },
  {
    type: 'html:attr',
    name: 'ajaxCart',
    targetSelector: '.module',
    property: 'data-ajaxcart',
  },
  {
    type: 'html:attr',
    name: 'editLink',
    targetSelector: '.module',
    property: 'data-editlink',
  },
  {
    type: 'html:attr',
    name: 'ajaxText',
    targetSelector: '.module',
    property: 'data-ajaxtext',
  },
  {
    type: 'html:attr',
    name: 'thankyouText',
    targetSelector: '.module',
    property: 'data-thankyouText',
  },
  {
    type: 'html:attr',
    name: 'successMessage',
    targetSelector: '.module',
    property: 'data-successMessage',
  },
  {
    type: 'html:attr',
    name: 'continue',
    targetSelector: '.module',
    property: 'data-continue',
  },
  {
    type: 'html:attr',
    name: 'effect',
    targetSelector: '.module',
    property: 'data-effect',
  },
  {
    type: 'html:attr',
    name: 'animation',
    targetSelector: '.module',
    property: 'data-ani',
  },
  {
    type: 'html:attr',
    name: 'interval',
    targetSelector: '.module',
    property: 'data-interval',
  },
]);

/**
 * (P) View More Atom Module
 */
export class GpPCartButton extends GpChildProduct {
  private throttleListenRefresh: Function;

  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    super(element, options);
    this.throttleListenRefresh = throttle(() => {
      this.render();
    }, 300);
  }

  /**
   * Return Atom data
   * @override Atom.getDataAtom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: '(P) Cart Button',
      slug: 'p-cart-button',
      groupName: 'Product',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.gf_add-to-cart',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Font[],
      version: 1,
      formControlSettings: formControlSettings,
    };
    return data;
  }

  /**
   * @override Atom.listenRefresh
   */
  listenRefresh() {
    STORE.events.listenOnlyOne(`refresh-${this.data.atom.id}`, this.throttleListenRefresh);
  }

  /**
   * @override Atom.getTargetClass
   */
  getTargetClass(): string {
    return '.gf_add-to-cart';
  }
}
